import CartLimitModal from "../CartLimitModal";
import EmptyCartConfirmation from "../EmptyCartConfirmation";
import { getLabel } from "../../../../hooks/use-labels";
import UniqueProductModal from "../UniqueProductModal";

const ProductNotificationModals = ({ type, onClose, onEmptyCart }) => {
  const modals = {
    cartLimit: () => <CartLimitModal onClose={onClose} />,
    otherSupplier: () => (
      <EmptyCartConfirmation
        onClose={onClose}
        onEmpty={onEmptyCart}
        description={getLabel("emptyCartConfirmationTitle")}
      />
    ),
    uniqueProductLimit: () => <UniqueProductModal onClose={onClose}/>
  };

  return modals[type]();
};

export default ProductNotificationModals;
